module.exports = __webpack_public_path__ + "static/img/grade_3.f9a1ed2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_3.png
// module id = z6fD
// module chunks = 89